export const enviarEmail = () => {
  const email = "comercial@brweapons.com.br"; // Defina o endereço de e-mail de destino
  const subject = "Assunto do Email"; // Defina o assunto do e-mail
  const body = "Corpo do email, pode ser uma mensagem predefinida."; // Defina o corpo da mensagem

  window.location.href = `mailto:${email}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
};

export const enviarEmailCompleto = (props) => {
  const {dsc_nome, dsc_empresa, dsc_email, num_telefone, dsc_mensagem } = props

  const E_MAIL_COMPLETO = `Olá,

    Nome: ${dsc_nome}
    E-mail: ${dsc_email}
    Tel: ${num_telefone}
    Empresa: ${dsc_empresa}

    ${dsc_mensagem}

    Atencionsamente,s

    ${dsc_nome}
  `  
  const email = "comercial@brweapons.com.br"; // Defina o endereço de e-mail de destino
  const subject =  `${dsc_nome} (${dsc_empresa}) - Contado de interesse`; // Defina o assunto do e-mail

  window.location.href = `mailto:${email}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(E_MAIL_COMPLETO)}`;
};
